import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";
import Link from "next/link";
import leadCareers from "/public/lead-careers.svg";
import leadCareersV from "/public/lead-careers_v.svg";
import photoCareers from "/public/photo-careers.webp";
import photoCareersSP from "/public/photo-careers_sp.webp";

const Careers = () => {
  const { parse } = useBudouX();

  return (
    <>
      <Link href="/careers/">
        <Container className="group relative z-20 aspect-[1.28/1] w-full cursor-pointer items-center justify-start overflow-hidden border-x-0 border-t  border-b-0 border-solid border-bdc-light transition hover:opacity-90 sm:aspect-2/1 md:aspect-3/1">
          <Inner className="flex h-full items-center px-6 sm:px-8 md:px-12 xl:px-0">
            <div className="z-10 flex flex-col justify-start gap-4">
              <h3 className="text-sm font-bold text-pri md:text-md">Careers</h3>
              <div>
                <div className="relative hidden w-[576px] max-w-fit md:block">
                  <Image
                    src={leadCareers}
                    alt="ともに成長できる仲間を求めています。"
                    quality={80}
                  />
                </div>
                <div className="relative block max-w-[88%] md:hidden">
                  <Image
                    src={leadCareersV}
                    alt="ともに成長できる仲間を求めています。"
                    quality={80}
                  />
                </div>
              </div>
              <p
                className="
                font-bold
                leading-relaxed
                text-nvy
                fluid-text-[12px,18px]
              "
              >
                トッカシステムズでは、新卒中途問わず正社員の通年採用を行っております。
                <br />
                自分らしいキャリアを築き、価値ある仕事がしたい方からのご応募をお待ちしております。
              </p>
            </div>
            <div className="absolute top-0 left-0 z-0 h-full w-full transform-gpu opacity-80 blur-[2px] transition duration-150 ease-out group-hover:scale-105 group-hover:ease-in">
              <span className="hidden md:block">
                <Image
                  src={photoCareers}
                  alt="Get in touch with ToccaSystems"
                  quality={80}
                  layout="fill"
                  objectFit="cover"
                />
              </span>
              <span className="block md:hidden">
                <Image
                  src={photoCareersSP}
                  alt="Get in touch with ToccaSystems"
                  quality={80}
                  layout="fill"
                  objectFit="cover"
                />
              </span>
            </div>
          </Inner>
        </Container>
      </Link>
    </>
  );
};

export default Careers;
